module.exports = __webpack_public_path__ + "img/09535_1.prt.8600e6fa.jpg";